import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { useJobsListener } from './hooks/useJobsListener';
import { createTasksDrawerStore, TasksDrawerStoreContext, useTasksDrawerStoreApi } from './tasksDrawerStore';
const JobsListenerBoundary = (param)=>{
    let { children } = param;
    const drawerStore = useTasksDrawerStoreApi();
    const hasUserInfo = useStore(selectors.user.hasUserInfo);
    useJobsListener({
        drawerStore,
        enabled: hasUserInfo
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export function TasksDrawerStoreProvider(param) {
    let { children, store } = param;
    const value = useMemo(()=>store !== null && store !== void 0 ? store : createTasksDrawerStore(), [
        store
    ]);
    return /*#__PURE__*/ _jsx(TasksDrawerStoreContext.Provider, {
        value: value,
        children: /*#__PURE__*/ _jsx(JobsListenerBoundary, {
            children: children
        })
    });
}
